import { Separator } from "@/components/ui/separator";
import { Mail, MapPin } from "lucide-react";

const footerLinks = {
  Prodotto: [
    { label: "Come Funziona", href: "#come-funziona" },
    { label: "Prezzi", href: "#prezzi" },
    { label: "FAQ", href: "#faq" },
  ],
  Supporto: [
    { label: "Assistenza Tecnica", href: "#" },
    { label: "Contattaci", href: "#" },
  ],
  Legale: [
    { label: "Privacy Policy", href: "#" },
    { label: "Termini di Servizio", href: "#" },
    { label: "Informazioni Legali", href: "#" },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-gradient-footer text-primary-foreground">
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div>
            <a href="#" className="flex items-center gap-1 mb-4">
              <span className="font-serif text-xl font-bold">Io</span>
              <span className="font-serif text-xl font-bold text-accent">Ci</span>
              <span className="font-serif text-xl font-bold">Sono</span>
              <span className="text-xs text-primary-foreground/50 font-sans ml-0.5">.org</span>
            </a>
            <p className="text-sm text-primary-foreground/50 leading-relaxed mb-6">
              Eredità digitale per famiglie che amano.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-primary-foreground/40">
                <Mail className="w-4 h-4" />
                <span>info@iocisono.org</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-primary-foreground/40">
                <MapPin className="w-4 h-4" />
                <span>Milano, Italia</span>
              </div>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-serif text-sm font-bold text-primary-foreground mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-primary-foreground/40 hover:text-primary-foreground/70 transition-colors duration-300">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="my-8 bg-primary-foreground/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-foreground/30">
            © {new Date().getFullYear()} IoCiSono.org. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-primary-foreground/30">
            Privacy Policy · Termini di Servizio · Informazioni Legali
          </p>
        </div>
      </div>
    </footer>
  );
};
